// The wait-clock lens of a queued run (DESIGN_SPEC §11.4.2). The live run clock sits in the cockpit's header bar.
//   <WaitClockLens job facts />   hero = time in the queue (mono 300) · queued since … · position · the run's settings
import { Kv, Lens, LensScore, MicroTags, Time, type KvRow } from "@/components/ui";
import { useClock } from "@/hooks";
import { clock, dur, ordinal } from "@/lib/format";
import type { Job } from "@/types";
import type { ReportFacts } from "./facts";

export function WaitClockLens({ job, facts }: { job: Job; facts: ReportFacts }) {
  const now = useClock(1000);
  const since = Date.parse(job.submitted_at);
  const waited = Number.isFinite(since) ? Math.max(0, now - since) : 0;
  const q = facts.queue;
  const rows: KvRow[] = [
    ["Profile", job.profile],
    ["Network", job.network],
    ["Timeout", job.timeout_secs ? dur(job.timeout_secs * 1000) : null],
    [
      "Submitted",
      <>
        <Time value={job.submitted_at} mode="clock" /> <small>UTC</small>
      </>,
    ],
    ["Labels", job.labels?.length ? <MicroTags items={job.labels} className="justify-end" /> : null],
  ];
  return (
    <Lens label="Under the lens: queue" eyebrow="Under the lens · queue" className="rhead-lens">
      <LensScore value={clock(waited)} clock of="waiting" />
      <p className="meta">
        queued since <Time value={job.submitted_at} mode="clock" />
        {q && ` · ${ordinal(q.position)} in line for ${q.profile}`}
      </p>
      <Kv rows={rows} />
    </Lens>
  );
}
